import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { useQueryClient } from '@tanstack/react-query';
import { useAccountSummaryV2Query } from '@syf-api-library/account-summary';
import { DrawerHeader as DrawerHeaderCL, SlideInModalLoader } from 'syf-component-library/ui/atoms';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { defaultCardArt } from '../../const/assets';
import { colors } from '../../defaultTheme';
import { isInstallmentLoan } from '../../helpers';
import normalizeStaticHostName from '../../helpers/normalizeStaticHostName';
import { t } from '../../strings/i18n';
const DrawerHeaderWrapper = styled(Inset) `
  border-bottom: 1px solid ${colors.mediumGrey};
`;
const DrawerHeader = ({ accountId, apiErrorCallback, hosts, isOpen, lang, multiAccountLast4 }) => {
    var _a, _b, _c, _d;
    const staticHostName = normalizeStaticHostName(hosts);
    const queryClient = useQueryClient();
    const apiConfig = {
        config: {
            apiErrorCallback,
            hosts,
            lang
        },
        keyProps: {
            accountId,
            accountIdType: 'guid'
        },
        queryOptions: Object.assign(Object.assign({}, queryClient.getQueryDefaults()), { enabled: isOpen })
    };
    const { data: accountSummary, isLoading } = useAccountSummaryV2Query(apiConfig);
    const displayName = (_a = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _a === void 0 ? void 0 : _a.displayName;
    const productType = (_b = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _b === void 0 ? void 0 : _b.type;
    const cardArtURL = (_c = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.card) === null || _c === void 0 ? void 0 : _c.cardArtURL;
    const summaryAccountLast4 = (_d = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.accountInfo) === null || _d === void 0 ? void 0 : _d.accountLast4;
    const accountLast4 = multiAccountLast4 || summaryAccountLast4;
    if (isLoading) {
        return _jsx(SlideInModalLoader, {});
    }
    const getHeaderSubTitleLabel = () => {
        if (isInstallmentLoan(productType)) {
            return 'loanEndingIn';
        }
        return 'accountEndingIn';
    };
    const drawerHeaderSubtitle = t(`label.${getHeaderSubTitleLabel()}`, {
        accountLast4
    });
    return (_jsx(DrawerHeaderWrapper, Object.assign({ all: "large" }, { children: _jsx(DrawerHeaderCL, { alt: displayName || 'Card Art', className: "modal-header", "data-cy": "modal-header", fallbackImage: `${staticHostName}${defaultCardArt}`, img: cardArtURL || `${staticHostName}${defaultCardArt}`, subtitle: drawerHeaderSubtitle, title: displayName }) })));
};
export default DrawerHeader;
